import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconHome = (props) => (
  <Icon fill="none" {...props}>
    <path
      d="M1 16.3356L14.8756 1L29 16.587"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.47998 17.2783V27.8058C5.47998 28.4658 6.00887 29 6.6622 29H23.3066C23.96 29 24.4889 28.4658 24.4889 27.8058V17.0584"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
